export enum Bank {
  Tinkoff = 'tinkoff',
  Sberbank = 'sberbank',
  Namba = 'namba',
  VTB = 'vtb',
  Amra = 'amra-bank',
  Amobile = 'amobile',
  AmobileAlternate = 'a-mobile',
  MBank = 'mbank',
  Kompanion = 'kompanion',
  Alfa = 'alfa',
  SberAbh = 'sberabh',
  Ozon = 'ozon',
}
